

class TimetableHelper {
  constructor(timetable, departureAddressObj, direction, placeType = null) {
    this.departureAddressObj = departureAddressObj;
    this.timetable = timetable;
    this.placeType = placeType;
    this.direction = direction;
    return this;
  }

  call() {
    if (this.timetable && this.timetable[this.direction]) {
      var timetableObj = this.timetable[this.direction];
      if (!this.departureAddressObj.selectedObject) {
        return '';
      }
      var selectedBusStop = this.departureAddressObj.selectedObject.value;
      if (this.placeType) {
        if (this.placeType == 'airport') {
          return timetableObj.busStops['airport'].time;
        } else {
          return timetableObj.busStops[selectedBusStop].time;
        }
      } else {
        if (timetableObj.isArrival) {
          return timetableObj.fromObject.time;
        } else {
          return timetableObj.busStops[selectedBusStop].time;
        }
      }
    }

  }

}
export default TimetableHelper;
